<template>
  <div>
    <main-header-plat-a-pat />
    <v-tab-vertical :legalItems="schema.legalItems" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import VTabVertical from '@/components/base/VTabVertical.vue';

export default {
  name: 'PatLegalesPage',
  components: {
    MainHeaderPlatAPat,
    VTabVertical,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('patLegalPage', ['schema']),
  },
  methods: {
    ...mapActions('patLegalPage', ['loadSchema']),
  },
};
</script>
